module.exports = __webpack_public_path__ + "media/V56.18724569.mp4";